import { FlexiText } from "appworks/graphics/elements/flexi-text";
import { Timer } from "appworks/utils/timer";
import { AbstractControl } from "../../abstract-control";

export class TimeControl extends AbstractControl {

    private timer: number;

    constructor(protected label: FlexiText) {
        super();

        const millisecondsLeft = 60000 - new Date().getSeconds() * 1000;

        this.updateClock(millisecondsLeft);
    }

    public destroy() {
        Timer.clearTimeout(this.timer);
    }

    private updateClock(milliseconds: number = 60000) {
        this.label.setText(this.getTime());

        this.timer = Timer.setTimeout(() => {
            this.updateClock();
        }, milliseconds);
    }

    private getTime() {
        const today = new Date();
        const hours = today.getHours();
        const minutes = today.getMinutes();

        return this.leadZeroes(hours) + ":" + this.leadZeroes(minutes);
    }

    private leadZeroes(n: number) {
        if (n < 10) {
            return "0" + n.toString();
        } else {
            return n.toString();
        }
    }
}
